import { Construtor } from './construtor';
import { ResultadoDashboardSingle } from './resultado-dashboard-single';

export class ResultadoDashboardMulti implements Construtor<ResultadoDashboardMulti> {

  public nomeIndicador: string;
  public resultados: ResultadoDashboardSingle[];
  public chartData: any[];

  constructor(object?: any) {
    this.resultados = new Array<ResultadoDashboardSingle>();
    this.chartData = new Array<any>();
    if (object !== undefined) {
      if (object instanceof (ResultadoDashboardMulti)) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }
  }

  parseFromJson(resultadoDashboard: any): void {
    this.nomeIndicador = resultadoDashboard.nomeIndicador;
    this.resultados = resultadoDashboard.resultados;
  }

  copyObject(resultadoDashboard: ResultadoDashboardMulti): void {
    this.nomeIndicador = resultadoDashboard.nomeIndicador;
    this.resultados = resultadoDashboard.resultados;
  }

  modeloCompleto(): boolean {
    return this.nomeIndicador !== undefined;
  }

  getNewInstance(object?: any): ResultadoDashboardMulti {
    return new ResultadoDashboardMulti(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/resultado-dashboard-multi.ts